export const INFINITE_PREFIX = 'infinite'
export const FAVORITES_SLUG = 'custom-my-favorites'
export const FAVORITES_INFINITE_SLUG = `${INFINITE_PREFIX}-${FAVORITES_SLUG}`
